import ntu from "../../assets/images/NTU.png";
import clhs from "../../assets/images/clhs.png";
import inti from "../../assets/images/inti.png";

const school_list = [
  {
    name: "Nanyang Technological University, Singapore",
    image: ntu,
    year: "Aug 2021 - May 2025",
    grade: "4.49/5.00",
    degree: "Bachelor of Engineering in Computer Science",
    description: [
      "Hall 7 Badminton Captain AY23/24",
      "Hall 7 Basketball Captain AY22/23",
      "SCSE IT Subcommittee (Front-end) AY22/23",
      "Coursework: Data Structure & Algorithms, Software Engineering, Object-Oriented Design & Programming, Introduction to Data Science & Artificial Intelligence, Introduction to Database, Natural Language Processing, Machine Learning, Data Analytics & Mining",
    ],
  },
  {
    name: "INTI International College Penang",
    image: inti,
    year: "2020 - 2021",
    grade: "4A*",
    degree: "GCE A-Level",
    description: [
      "Top Achiever Award",
      "Subjects: Further Mathematics, Chemistry, Physics, Mathematics",
    ],
  },
  {
    name: "Chung Ling (National Type) High School",
    image: clhs,
    year: "2015 - 2019",
    grade: "7A+ 2A 1A- (Straight As)",
    degree: "Sijil Pelajaran Malaysia (SPM)",
    description: [
      "Outstanding Graduate of the Year Award",
      "President of Counselling & Guidance Unit",
      "President of Basketball Club",
      "Vice President of Mathematics and Science Society",
    ],
  },
];

export default school_list;
